export default function Services() {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Traumatología y Ortopedia',
      description: 'Especialista en cirugía, TPLO (Osteotomía de Nivelación de la Meseta Tibial) para rotura de ligamento cruzado, tratamiento de fracturas complejas, luxación de rótula, deformidades angulares y displasias. Servicio de traumatología veterinaria en Almería con equipamiento de última generación.',
      features: [
        'Cirugía TPLO en Almería',
        'Tratamiento de fracturas',
        'Luxación de rótula',
        'Deformidades angulares',
        'Displasias articulares'
      ]
    },
    {
      icon: 'ri-microscope-line',
      title: 'Cirugía Oncológica',
      description: 'Cirugía oncológica veterinaria especializada en Almería. Resección de tumores con márgenes oncológicos adecuados (adrenal, hígado, bazo, pulmón...), mastectomías, amputaciones, cirugía reconstructiva post-resección y biopsias especializadas. Trabajo coordinado con oncólogos para tratamiento integral.',
      features: [
        'Resección de tumores (adrenal, hígado, bazo, pulmón)',
        'Mastectomías',
        'Cirugía reconstructiva',
        'Biopsias especializadas',
        'Tratamiento integral'
      ]
    },
    {
      icon: 'ri-brain-line',
      title: 'Neurocirugía Veterinaria',
      description: 'Especialista en neurocirugía veterinaria, tratamiento de hernias discales, compresiones vertebrales, slot ventral, hemilaminectomía, enfermedad degenerativa lumbosacra y luxaciones vertebrales. Equipamiento especializado para cirugía de columna vertebral.',
      features: [
        'Hernias discales',
        'Slot ventral',
        'Hemilaminectomía',
        'Cauda equina',
        'Luxaciones vertebrales'
      ]
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Cirugía Torácica',
      description: 'Cirugía veterinaria torácica especializada en Almería. Procedimientos complejos como cirugía de diafragma, hernias diafragmáticas, traumatismos torácicos, lobectomías pulmonares y resección de timomas.',
      features: [
        'Cirugía de diafragma',
        'Hernias diafragmáticas',
        'Traumatismos torácicos',
        'Lobectomías pulmonares',
        'Timomas'
      ]
    },
    {
      icon: 'ri-capsule-line',
      title: 'Cirugía Abdominal',
      description: 'Cirugía veterinaria abdominal avanzada en Almería. Procedimientos especializados como shunt portosistémico, cirugía digestiva e intestinal, resecciones intestinales, esplenectomías, nefrectomías y otras intervenciones complejas de tejidos blandos.',
      features: [
        'Shunt portosistémico',
        'Cirugía digestiva/intestinal',
        'Resecciones intestinales',
        'Esplenectomías',
        'Nefrectomías'
      ]
    },
    {
      icon: 'ri-lungs-line',
      title: 'Síndrome Braquicefálico',
      description: 'Tratamiento quirúrgico del síndrome braquicefálico (BOAS) en razas como Bulldog, Carlino y Boston Terrier. Corrección de estenosis de narinas, resección de paladar blando elongado y eversión de sáculos laríngeos para mejorar la respiración.',
      features: [
        'Estenosis de narinas',
        'Paladar blando elongado',
        'Sáculos laríngeos',
        'Mejora respiratoria',
        'Razas braquicefálicas'
      ]
    },
    {
      icon: 'ri-file-text-line',
      title: 'Servicio de Informe Radiológico',
      description: 'Interpretación especializada de estudios radiológicos en traumatología y ortopedia con informes detallados y recomendaciones terapéuticas. Análisis especializado de estudios radiológicos en traumatología.',
      features: [
        'Interpretación radiografías',
        'Evaluación implantes',
        'Diagnóstico fracturas',
        'Informes detallados',
        'Recomendaciones terapéuticas'
      ]
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Seguimiento Postoperatorio',
      description: 'Control radiológico del progreso y evolución del tratamiento. Seguimiento especializado para garantizar la correcta recuperación y consolidación de las intervenciones quirúrgicas realizadas.',
      features: [
        'Control post-TPLO',
        'Consolidación fracturas',
        'Evaluación radiológica',
        'Seguimiento personalizado',
        'Telemedicina veterinaria'
      ]
    },
    {
      icon: 'ri-user-voice-line',
      title: 'Consulta de Especialidad de Traumatología y Ortopedia',
      description: 'Servicio de consulta especializada en traumatología y ortopedia veterinaria. Segunda opinión especializada y valoración de casos complejos para clínicas veterinarias en Almería y toda España. Asesoramiento quirúrgico personalizado.',
      features: [
        'Consulta especializada',
        'Segunda opinión',
        'Valoración de casos',
        'Asesoramiento quirúrgico',
        'Planificación quirúrgica'
      ]
    },
    {
      icon: 'ri-stethoscope-line',
      title: 'Telemedicina',
      description: 'Servicio de interpretación de radiología (trauma). Segunda opinión especializada y valoración de casos complejos de forma remota para clínicas veterinarias en Almería y toda España.',
      features: [
        'Consulta especializada remota',
        'Interpretación radiológica',
        'Segunda opinión',
        'Valoración de casos',
        'Asesoramiento quirúrgico'
      ]
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-accent-100 text-accent-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Servicios Especializados
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            <strong>Cirugía Veterinaria Especializada</strong> en Almería
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Como <strong>veterinario especialista en cirugía</strong>, ofrezco un servicio móvil completo de <strong>cirugía veterinaria en Almería</strong> y provincia, llevando equipamiento de última generación directamente a tu <strong>clínica veterinaria</strong>.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-accent-200 hover:-translate-y-2"
            >
              <div className="p-8">
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-accent-100 to-accent-200 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${service.icon} text-3xl text-accent-600`}></i>
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                  <strong>{service.title}</strong>
                </h3>

                {/* Description */}
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <div className="w-5 h-5 bg-accent-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-accent-600 text-xs"></i>
                      </div>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            ¿Necesitas una <strong>Consulta o Cirugía Especializada</strong>?
          </p>
          <p className="text-gray-600 mb-6 max-w-3xl mx-auto">
            Contacta conmigo para evaluar el caso, obtener una segunda opinión o programar la intervención en tu propia clínica. Como <strong>veterinario especialista en Almería</strong> y otras zonas de España, aporto toda la experiencia para esa cirugía que necesitas.
          </p>
          <a
            href="#contacto"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-accent-600 to-accent-700 text-white px-8 py-4 rounded-lg font-semibold hover:from-accent-700 hover:to-accent-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span>Consultar Caso</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}